import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/3eb073a4/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const Caption = makeShortcode("Caption");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <PageDescription mdxType="PageDescription">
      <p>{`When exporting something you have the ability to change the format of the object or resource you are exporting out external to the system. Downloading transfers a resource from a remote system to a local system without changing its format.`}</p>
    </PageDescription>
    <h4 {...{
      "id": "status"
    }}>{`Status:`}</h4>
    <p>{`Experimental`}</p>
    <h4 {...{
      "id": "maintainers"
    }}>{`Maintainers:`}</h4>
    <p><a parentName="p" {...{
        "href": "https://github.com/vikkipaterson"
      }}>{`Vikki Paterson`}</a>{`, `}<a parentName="p" {...{
        "href": "https://github.com/chloepoulterdesign"
      }}>{`Chloe Poulter`}</a></p>
    <AnchorLinks mdxType="AnchorLinks">
      <AnchorLink mdxType="AnchorLink">Intuitive default name</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Editable name</AnchorLink>
      <AnchorLink small mdxType="AnchorLink">Optional extras</AnchorLink>
    </AnchorLinks>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1120px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "51.42857142857144%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsSAAALEgHS3X78AAAB20lEQVQoz32RTWsTURSG81tE3eqiFBdBBCEJsRHTaD8oKITMNFlJRXDpMthJZubOR+YzCS1ISPqXgqYLwSStonYyqS5e77mTaCTg4oEz557zvDN3UtHVFZ6/OECxVMKT4jYebRWQ5xRLT7Gzt4ed3YRnC6je5mc0Q7NbhcfI5fPY3T9AFEVIXVx+wf0HD1GtViFJMg4PqxwZsiyjUqmgXC7zvvQPsiyhVqsliD0JR69eYzaLkZpOpzylALvlwvUCeH6IIAjQbrfR6/XQ7/cxGAw4ZxicLeB1t9sVc57nwXVddDodzOfzRJjL5WAYBjRNFTQaDYRhiPF4jDiOEfPBeBYhjr7hevYd0Y+vOD05wfGxAlWlHU2IaTY1mUyQzWaFsNlsChRFEQPD4RCj0Qjn55xPlxhNfuHj+BofPs8Rdkj4TsyT1Pf9v8JMJgPLsmDbNkzTRKvVQr1eRzqdxsbmPWzevY07pQZuvfmJGy+nuHl0gbfqe7g2g2klO2tCapKQZI7jiJqSCabr0A0bTeZAUS0omgXGDPFVhM7PaWdNSG9JF7y86KWcLj8MfDg2F+kaDKYnIRzGmAhdE1ISNZeQjAL+9HiAyZ9JonMJwRbQT1kTLtNW+V9v9WxV+BtuUyQXW/ZY2gAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Example of an export modal in context",
        "title": "Example of an export modal in context",
        "src": "/static/a4b711895863ece156af7eca76a442c4/026f9/0.png",
        "srcSet": ["/static/a4b711895863ece156af7eca76a442c4/d6747/0.png 288w", "/static/a4b711895863ece156af7eca76a442c4/09548/0.png 576w", "/static/a4b711895863ece156af7eca76a442c4/026f9/0.png 1120w"],
        "sizes": "(max-width: 1120px) 100vw, 1120px",
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <Caption mdxType="Caption">Example of an export modal</Caption>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "47.47774480712166%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAYAAAAywQxIAAAACXBIWXMAAAsSAAALEgHS3X78AAABm0lEQVQoz62Qu0oDQRSGfTIRrbKbgPoANuImXl9A3CBGzW72fslekk1ELCxtvEZBC1tNIA9gJViopBAEYX7njBgjthY/Z5jzzzf/OWOMsQ8A/yJijfEDLs5PsFPdhWHa0PQaqlyW48IPQnhB8Et0Z5gWqpouvLphYnOrgrv7LqFAQFZaXGaTU1NsemaW5XISy0kSk2WZFQoFls/nRR2VLOeZJMlckuiPj0+w45NTRiyRcGV1DZXKNtJGJtRsNoXSNEUURbw2RnoZ2q0W2u320Bfw5P1+f5gQxWIR5bKKqF6HbdvwPA+6rqPT6WAwGODl5RmvTw94Hzzi+uoMGh/Xdd2ht1Yz0O3+jIxSqcSBZdE0DAOmaXJTDWEYopEmaLb2EV++IbwBnINbGNo291jCa1mW8PZ6vR+goigCSCP6vi/AdZ6W7hRlAYtLq5hXDzG3cYR1bQ9R6HFfIEalTwn6K+EokAy0NwImSYIs+9rZXsNHFluoB19jfougtJ4/QFVVBYBgVOM4FmnpAZ3jJIXrBbAdB86ICKpp2hD4CcuxD0vc0qeeAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Example of a download modal in context",
        "title": "Example of a download modal in context",
        "src": "/static/2d045ce2c78b1838af26528b1a3b3aff/fb070/download0.png",
        "srcSet": ["/static/2d045ce2c78b1838af26528b1a3b3aff/d6747/download0.png 288w", "/static/2d045ce2c78b1838af26528b1a3b3aff/09548/download0.png 576w", "/static/2d045ce2c78b1838af26528b1a3b3aff/fb070/download0.png 1152w", "/static/2d045ce2c78b1838af26528b1a3b3aff/fb104/download0.png 1728w", "/static/2d045ce2c78b1838af26528b1a3b3aff/902fb/download0.png 2304w", "/static/2d045ce2c78b1838af26528b1a3b3aff/6690f/download0.png 3370w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <Caption mdxType="Caption">Example of a download modal in the context of a product</Caption>
    <h2 {...{
      "id": "intuitive-default-name"
    }}>{`Intuitive default name`}</h2>
    <p>{`When a resource is given an intuitive name by default and there is no choice of an export or download location, the export occurs on the click of the Export button and nothing additional is displayed.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1120px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "44.285714285714285%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAYAAAAywQxIAAAACXBIWXMAAAsSAAALEgHS3X78AAABFElEQVQoz61RSU7EQAzMaxH/QPMEOPECzvABXjE5kH3f9w2SImXUzIQTSFgqueWyy+VEwx7btv0Jl9gOIKUdG34Xy7Lg433B4ytwegHunoG35GuBphwGQQDTNBFFEWzbFoRhCMMw4Pu+gLznedB1fccZp6cAtw8mbu4dnP1Flh0ELcsSQdd1RYxwHEdqFCLiOJYchhGWdkftAUMMrLMcrqkzqqpClmXoug5FUUhumgZlWaLve8l1Xctb8WlWwHZ390GMaZ4vDhl5nst2DqVp+i3GJW3bCk8h1hV//UmmaTqezGYK0ikHKKwEOfxTkDxrSZJIH3/UweE4jnIONw3DgHk/Qb3ZTJ5g/ZpXM+u6Hh3+R1DnE/R7svI311mLAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of an export button on a data table",
            "title": "Example of an export button on a data table",
            "src": "/static/32554e5c00c88f8c861be075a6e15619/026f9/1.png",
            "srcSet": ["/static/32554e5c00c88f8c861be075a6e15619/d6747/1.png 288w", "/static/32554e5c00c88f8c861be075a6e15619/09548/1.png 576w", "/static/32554e5c00c88f8c861be075a6e15619/026f9/1.png 1120w"],
            "sizes": "(max-width: 1120px) 100vw, 1120px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>
    <Row mdxType="Row">
 <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "29.21195652173913%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAGCAYAAADDl76dAAAACXBIWXMAAAsSAAALEgHS3X78AAAAgUlEQVQY02P4jwb+/YPR//7/+fsfiP9B8X8whqmBqUMHDNgEEYqRdf0DY1wG4TTwL9QVt178+x8w+f//iBn//kdN//nfvff//5p1UDWkuBBm4PVn//679vz/Hzj53//giV//mzX//1+4/B/pBuL38n/SvYwcKRCX/IOz//77RzBSALbd0oKxPm6mAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of a download button",
            "title": "Example of a download button",
            "src": "/static/41f6330eb746af8c3835be78801bc5c8/fb070/download1.png",
            "srcSet": ["/static/41f6330eb746af8c3835be78801bc5c8/d6747/download1.png 288w", "/static/41f6330eb746af8c3835be78801bc5c8/09548/download1.png 576w", "/static/41f6330eb746af8c3835be78801bc5c8/fb070/download1.png 1152w", "/static/41f6330eb746af8c3835be78801bc5c8/c3e47/download1.png 1472w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Example of a download button</Caption>
 </Column>
    </Row>
    <h2 {...{
      "id": "editable-name"
    }}>{`Editable name`}</h2>
    <p>{`When a file’s name can be edited before exporting or downloading, a dialog containing an editable textbox should be presented to the user. The textbox should be pre-populated with the file’s default name.`}</p>
    <p>{`When downloading, the file extension is not displayed.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "736px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "60.733695652173914%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAABPklEQVQoz6WSu06EQBiFKW3UzthpBIk+gDFrY0KjcSH7ALYkq7GytvJWWPqKNGABzMJwXZjjDIQFkVWMf/LlzDAzJ2eYX2KMQZTQ/9B4SM2gbzq2umdFSf0P3Y1/SbZK2F1wXRe2bSMIAkRR9CuU0mrvWkPHcWBZFsIwHEUgGDJsJnEcVyl930eWZV/J8wGWiJMEZVkOJ0z4oriGMBbjmhSp0GiBhBKkXFsI8iQcTiiMTNOEYRjQdR3T6ZTD9eoCl7NraE8fOH8DJs9LTF4KnL0WOHksMHsvQKLao+wain+haRpUVYWiKJBlGbJyCOVgD/vHp9i9cbBzD2zeMmzdAducjTlw9MAfM6zyccNe2xBC4HlepS0+Z8EPlXAp4PE0HmUrJTGrkg029og2/qHB8b2xxWuthdVXarWlMRP6CWWxfojsDVRpAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of an export modal",
            "title": "Example of an export modal",
            "src": "/static/ebe5e2b534b0e54159a9c8c78715c586/ddf7f/2.png",
            "srcSet": ["/static/ebe5e2b534b0e54159a9c8c78715c586/d6747/2.png 288w", "/static/ebe5e2b534b0e54159a9c8c78715c586/09548/2.png 576w", "/static/ebe5e2b534b0e54159a9c8c78715c586/ddf7f/2.png 736w"],
            "sizes": "(max-width: 736px) 100vw, 736px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "736px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "60.733695652173914%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAABfElEQVQoz6WSy07CQBSGceUTuNdFa+QNfADWxqgr976Okbh2U3BnWHFZabgkRoImEhMTlVuEFChIOy0gtDO/p0C5GFkgf/Lln04zf845OT4hBFy5vg5ehs87rCsvwzef7jgOOOewbXslFiqcL1lVVXwUCtANA1a3C9OylmJNXGdseeBXvY7Pt3cYzSZMrQWmaWB0Zo3mzD2aGoxqDVarDTFOmwWOPuhOL1dQfc6jUy6jUyKKJeifVei1GqGi41FVoasNtF9eoRcrfwe6cvp9ONSCzUzYBjm17gyH4A7NaWASbAEMTcC2pgVhGkhyh/uQzSKZTiOVycxIJenuHomcgfjTN2KPPaKPOBHN9XCb72Ng/5qhK0aVBQIB+P1+yLIMWZIgSTJ2pR1s7+1j86SOjVNai0MO3xE9PCYOBLbOBDQ2zuDzgUNqLRKJQFEUhMPhESHXQwqU6xtcRru4SADBOCcEggmB85jA1Z1Ab/DvxRarL/ZSOP3nmPgi8xk/3oZ91/Bp6gMAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of validation errors",
            "title": "Example of validation errors",
            "src": "/static/93f62b874f92f302d940ea375f8e48a0/ddf7f/newimage1.png",
            "srcSet": ["/static/93f62b874f92f302d940ea375f8e48a0/d6747/newimage1.png 288w", "/static/93f62b874f92f302d940ea375f8e48a0/09548/newimage1.png 576w", "/static/93f62b874f92f302d940ea375f8e48a0/ddf7f/newimage1.png 736w"],
            "sizes": "(max-width: 736px) 100vw, 736px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Validate the edited name's extension.</Caption>
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "736px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "60.733695652173914%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAAAk0lEQVQoz61TXQvDIAz0///D9r0droLOb1+8TUegm2xCNXDEhHjmjDJMNpZzroviR0Ac7DsxTEitUvKq0f6PDq0xUFIixoiUEkIIXXjvf0vebhzLuoJzDqUUzOuAf9Ba17qW8B1BPjzux4F93yCEgLW2S+qcawkpCMFXGUVy8aW4h0by+ULzadJDQ5n+DqcSzv56T8IQs31MAk6QAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of an export modal in its \"Exporting\" state",
            "title": "Example of an export modal in its \"Exporting\" state",
            "src": "/static/5f3b9683a8915a33d140d96e86d0503b/ddf7f/3.png",
            "srcSet": ["/static/5f3b9683a8915a33d140d96e86d0503b/d6747/3.png 288w", "/static/5f3b9683a8915a33d140d96e86d0503b/09548/3.png 576w", "/static/5f3b9683a8915a33d140d96e86d0503b/ddf7f/3.png 736w"],
            "sizes": "(max-width: 736px) 100vw, 736px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Example of an export modal in its "Exporting" state</Caption>
      </Column>
    </Row>
    <h2 {...{
      "id": "optional-extras"
    }}>{`Optional extras`}</h2>
    <h3 {...{
      "id": "specify-the-export-or-download-location"
    }}>{`Specify the export or download location`}</h3>
    <p>{`When specifying the download location of a resource, clicking the primary “download” button activates the browser’s default location panel. The file is downloaded once a location is selected and the user clicks Save.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "736px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "60.733695652173914%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAAC3ElEQVQoz12S2U8TURSHG9BAy9ZWuoJVMSilLV3pMFNKO11AATUoBgE1IYaQWhKDaAwPFAzywAN7wr/Ak2+8ukQRFfclIdEXX/0rPu9UY42T/ObeOXfOd8495+gQz/cfP3nx7hvP9g94sveZp8/2ePn6Ha/ffGD/7Ufef/zK2w9feCW+Ndvu3j6Pnjzn8YvP4v9P7O7ucnBwoKHQaa/8g4dY4gWOZhawytO45SF88VGa2y/j67qG1HeTcM8EgcwNWjtHcSsjnJYGMcv3OBK5SX29hfHx8RLw7p3bOOxWjrkaaPO2kunuJZnuoUNJFJXK9hLvSpNQu0llzpISZ53xFN0ZlUsD/aTUBPfvz5WAMzMzNDQ00NjYiBSNMjx8BVVVkSSFSCgi9mmkdon2jrgIdAa/z0+b0ODgJfL5HNevX2Vzc6MEnJ6exmw2U2+x4PV46OvtRZEVfF5/UanMGZSOGOFojHgyS6AtKIBBRkdGOHeuH4/bzcbGf0CT0YjFaiUYCJBOpwmLzAL+kCiBH7WnH1mOEQqGf9t8AWH3MTQ0hOdUM4d0OgqzsyXg5OQker0eu91O04kTJLqSf5yDRMJRspks5y9cpEvYlWiIeCxGIt1HUs1wvNGJS5Tr1q2pEnBqagqjyNDpdGKz2mg57SYpnNsjUXweL1IkhBpXRBk6kGMSMUXGE07R4m7j5MlmjljsTEzkSsBcLkdlZWWxMSajicPlh2kVdQlEtCw9dCohvC2nOOp0iK7LNB1vwlBRgVUENxrN6MSVh4dH/pnDfJ6qqipcLhc1NTWUl5dTW1uLyWTEYDBQIZy1ta6uDqtonNZA7UZ6vYHq6uoicGBgoAQcGxsrGjUHbdVUVlb2d69Jq7HD4SjW2WazieysIqDpr082my0Bd3Z2WFhYYHl5mcXFRQqFArOia5rm5+eZm5tjZWVFzNomq6urrK2tsb6+XhyVra0tlpaW2N7eLgJ/AWnn6lUvoAA+AAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of specifying an export location",
            "title": "Example of specifying an export location",
            "src": "/static/fda8cbd0a36a7c2550b53f2cb3317af6/ddf7f/newimage2.png",
            "srcSet": ["/static/fda8cbd0a36a7c2550b53f2cb3317af6/d6747/newimage2.png 288w", "/static/fda8cbd0a36a7c2550b53f2cb3317af6/09548/newimage2.png 576w", "/static/fda8cbd0a36a7c2550b53f2cb3317af6/ddf7f/newimage2.png 736w"],
            "sizes": "(max-width: 736px) 100vw, 736px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>
    <h3 {...{
      "id": "passive-success-modal"
    }}>{`Passive success modal`}</h3>
    <p>{`You can choose to show a passive modal when an export has succeeded.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "736px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "69.02173913043478%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAYAAAAvxDzwAAAACXBIWXMAAAsSAAALEgHS3X78AAAArUlEQVQ4y81Tyw7CIBDk//9QPTal0bZAhBS0hBFoUFpbjSkHN5ksu1kmMzwICgcpTuici4uQ9yBxkGVjN2GSmpp5nQ9/izQ3U6jkFZwzDMMAY8wTWuvYWyL0pZSw1q5brmiHw/GEtr2AMY6+731mcdMWhBAYx3FJGEtUrUZz7tBQCupR13XMnwiVUu8KU3G/aRhvI7cbsGY3x4zwdaCT0q0b/OlSir/DooR//5cf+QVSN44VtqwAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of a passive success modal",
            "title": "Example of a passive success modal",
            "src": "/static/0f90c4ebc5aa7007777673f7d733bcb9/ddf7f/newimage3.png",
            "srcSet": ["/static/0f90c4ebc5aa7007777673f7d733bcb9/d6747/newimage3.png 288w", "/static/0f90c4ebc5aa7007777673f7d733bcb9/09548/newimage3.png 576w", "/static/0f90c4ebc5aa7007777673f7d733bcb9/ddf7f/newimage3.png 736w"],
            "sizes": "(max-width: 736px) 100vw, 736px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>
    <h3 {...{
      "id": "errors-and-failures"
    }}>{`Errors and failures`}</h3>
    <p>{`In the event of an error, display the error in the modal.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "736px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "69.02173913043478%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAYAAAAvxDzwAAAACXBIWXMAAAsSAAALEgHS3X78AAAAoElEQVQ4y82T2wrDIAyGff9H7O6ltiKiTgXFzMgCc2sdrF5M+DEH/UiIMpi82HRgKaUZuF8RMdh74DKQSqXgmf9t0fmuQmMtKKXAew8xRgghNPtMmLf1Ts75uOV9FXBbFtilbGBjTLswktYaUko9EBBaA/ealNsGqxDAOW+HnXNDIOY/KiQnPNvEdlGjdl/VAbsBHEzup6FMf4dTgX//lx8H1FKzDi1aPwAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of an error state modal",
            "title": "Example of an error state modal",
            "src": "/static/1d39e1da845dc433826a10e833a8b818/ddf7f/newimage4.png",
            "srcSet": ["/static/1d39e1da845dc433826a10e833a8b818/d6747/newimage4.png 288w", "/static/1d39e1da845dc433826a10e833a8b818/09548/newimage4.png 576w", "/static/1d39e1da845dc433826a10e833a8b818/ddf7f/newimage4.png 736w"],
            "sizes": "(max-width: 736px) 100vw, 736px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>
    <h3 {...{
      "id": "success-notification"
    }}>{`Success notification`}</h3>
    <p>{`A notification can be used to alert the user that an export has been successful.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "736px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "69.02173913043478%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAYAAAAvxDzwAAAACXBIWXMAAAsSAAALEgHS3X78AAAA1UlEQVQ4y82Ty4rCQBRE/f8fcuHCEV0IMuMrDxMz2hohDhmJ4quTdHKMLoZBDCaiYMHlbm4XVVR1hSej8lLCNE3/dpH5/yaXsAzpXcJrpfdw6+6mZZUo+mubYTDG8L8xVxN038EKBPPoh5lcEiZRMctnRCqivdZoel9Uh3VqVouq9kFDdOhtbEw546BkcUIZh+iHKcZR8Lky6QZWtg0G20ylcrHjBcckLKMwxtm7ODsX/de5jOaPGQVTROghpIcsYpmU3PSum/BQynlVKZ3y04r9ln/5BJWdToVSzPWQAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of a success notification",
            "title": "Example of a success notification",
            "src": "/static/a4b7cd2ebec56bdc45adfaa3e05cecbb/ddf7f/newimage5.png",
            "srcSet": ["/static/a4b7cd2ebec56bdc45adfaa3e05cecbb/d6747/newimage5.png 288w", "/static/a4b7cd2ebec56bdc45adfaa3e05cecbb/09548/newimage5.png 576w", "/static/a4b7cd2ebec56bdc45adfaa3e05cecbb/ddf7f/newimage5.png 736w"],
            "sizes": "(max-width: 736px) 100vw, 736px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      